// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messageItem__ixB6h {
  max-width: 330px;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  padding: 15px;
  background-color: var(--tables-secondary-row-sub-title-surface);
  border-radius: 2px;
  position: relative;
  border: 1px solid transparent;
}

.userMessage__fDFqh {
  margin-left: auto;
}

.errorMessage__JlEbx {
  border-color: var(--inputs-error-stroke);
}

.messageHead__dfTc7 {
  display: flex;
  align-items: center;
  column-gap: 10px;
}

.userAvatar__vG9Tf {
  width: 20px;
  height: 20px;
  object-fit: cover;
  border-radius: 50%;
}

.messageDateTime__uja0l {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: var(--tables-primary-row-text-additional);
}

.assistantIcon__wmr0s {
  width: 20px;
  height: 20px;
}

.messageText__rw_5l {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: var(--inputs-filled-text);
  padding-left: 30px;
  padding-right: 15px;
}
.messageText__rw_5l pre {
  padding: 8px;
  border-radius: 6px;
  overflow-x: auto;
  background-color: var(--inputs-filled-filled-surface);
}
.messageText__rw_5l pre code {
  padding: 0px;
  background-color: none;
}
.messageText__rw_5l code {
  padding: 4px;
  background-color: var(--inputs-filled-filled-surface);
}
.messageText__rw_5l ul,
.messageText__rw_5l ol {
  padding-left: 20px;
  margin-top: 0;
  margin-bottom: 8px;
}
.messageText__rw_5l li p {
  display: inline;
}
.messageText__rw_5l p {
  margin: 0;
}

.messageError__rOpk0 {
  cursor: pointer;
}
.messageError__rOpk0:focus {
  outline: none;
}
.messageError__rOpk0 path {
  stroke: var(--buttons-surface);
}

.messageActions__bScjC {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  column-gap: 10px;
}

.copyIcon__DpcMI {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.copyIcon__DpcMI:focus {
  outline: none;
}
.copyIcon__DpcMI path {
  fill: var(--buttons-surface);
}`, "",{"version":3,"sources":["webpack://./../src/components/common/ChatComponent/components/ChatMessage/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,+DAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;AAzEF;;AA4EA;EACE,iBAAA;AAzEF;;AA4EA;EACE,wCAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gDAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;AAzEF;AA2EE;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,qDAAA;AAzEJ;AA2EI;EACE,YAAA;EACA,sBAAA;AAzEN;AA6EE;EACE,YAAA;EACA,qDAAA;AA3EJ;AA8EE;;EAEE,kBAAA;EACA,aAAA;EACA,kBAAA;AA5EJ;AAgFI;EACE,eAAA;AA9EN;AAkFE;EACE,SAAA;AAhFJ;;AAoFA;EACE,eAAA;AAjFF;AAmFE;EACE,aAAA;AAjFJ;AAoFE;EACE,8BAAA;AAlFJ;;AAsFA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAnFF;;AAsFA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAnFF;AAqFE;EACE,aAAA;AAnFJ;AAsFE;EACE,4BAAA;AApFJ","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.messageItem {\n  max-width: 330px;\n  display: flex;\n  flex-direction: column;\n  row-gap: 10px;\n  padding: 15px;\n  background-color: var(--tables-secondary-row-sub-title-surface);\n  border-radius: 2px;\n  position: relative;\n  border: 1px solid transparent;\n}\n\n.userMessage {\n  margin-left: auto;\n}\n\n.errorMessage {\n  border-color: var(--inputs-error-stroke);\n}\n\n.messageHead {\n  display: flex;\n  align-items: center;\n  column-gap: 10px;\n}\n\n.userAvatar {\n  width: 20px;\n  height: 20px;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n.messageDateTime {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  color: var(--tables-primary-row-text-additional);\n}\n\n.assistantIcon {\n  width: 20px;\n  height: 20px;\n}\n\n.messageText {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  color: var(--inputs-filled-text);\n  padding-left: 30px;\n  padding-right: 15px;\n\n  pre {\n    padding: 8px;\n    border-radius: 6px;\n    overflow-x: auto;\n    background-color: var(--inputs-filled-filled-surface);\n\n    code {\n      padding: 0px;\n      background-color: none;\n    }\n  }\n\n  code {\n    padding: 4px;\n    background-color: var(--inputs-filled-filled-surface);\n  }\n\n  ul,\n  ol {\n    padding-left: 20px;\n    margin-top: 0;\n    margin-bottom: 8px;\n  }\n\n  li {\n    p {\n      display: inline;\n    }\n  }\n\n  p {\n    margin: 0;\n  }\n}\n\n.messageError {\n  cursor: pointer;\n\n  &:focus {\n    outline: none;\n  }\n\n  path {\n    stroke: var(--buttons-surface);\n  }\n}\n\n.messageActions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  column-gap: 10px;\n}\n\n.copyIcon {\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n\n  &:focus {\n    outline: none;\n  }\n\n  path {\n    fill: var(--buttons-surface);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messageItem": `messageItem__ixB6h`,
	"userMessage": `userMessage__fDFqh`,
	"errorMessage": `errorMessage__JlEbx`,
	"messageHead": `messageHead__dfTc7`,
	"userAvatar": `userAvatar__vG9Tf`,
	"messageDateTime": `messageDateTime__uja0l`,
	"assistantIcon": `assistantIcon__wmr0s`,
	"messageText": `messageText__rw_5l`,
	"messageError": `messageError__rOpk0`,
	"messageActions": `messageActions__bScjC`,
	"copyIcon": `copyIcon__DpcMI`
};
module.exports = ___CSS_LOADER_EXPORT___;
